import { Checkbox, DataSource, Label, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOffice401kRatesList extends Layout {
    checkboxPayee401kRateonHold: Checkbox;
    labelTo: Label;
    searchpanel401kRates: SearchPanel;
    sourceOffice401kRateList: DataSource;
    tablePayee401kRateList: Table;
    textboxActiveDatesFrom: Textbox;
    textboxActiveDatesTo: Textbox;
    textboxPayee401kRatecalculationMethodSearch: Textbox;
    textboxPayee401kRatecontribTypeSearch: Textbox;
    textboxPayee401kRatedeductCodeIdSearch: Textbox;
    textboxPayee: Textbox;
    textboxPayeestatusSearch: Textbox;
}
